import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {env} from "../../../constants/global.vars";
import {Storage} from "../../../services/localstorege.service";
import {gameSlug, loadGames} from "../../games/games";
import paths from "../../../paths";
import logo from "../../../assets/img/logo.png";
import chevronRight from "../../../assets/feather/chevron-right.svg";

const POPULAR_COUNT = 9;

export function PopularGames() {
    const navigate = useNavigate();
    const [games, setGames] = useState<any[]>([]);

    useEffect(() => {
        const cached = Storage.get("games");
        if (cached && cached.length > 0) {
            setGames(cached);
            return;
        }
        loadGames().then((data: any[]) => setGames(data)).catch(() => setGames([]));
    }, []);

    const popular = games.filter((game: any) => game.is_active).slice(0, POPULAR_COUNT);

    if (popular.length === 0) {
        return null;
    }

    return <div className={"popular-games"}>
        <div className={"popular-games-head"}>
            <h3>En Çok Oynanan Oyunlar</h3>
            <button onClick={() => navigate(paths.games.url)}>
                Hepsine Bak
                <img src={chevronRight} alt={""}/>
            </button>
        </div>
        <div className={"popular-games-grid"}>
            {popular.map((game: any) => {
                return <div key={`popular-game-${game.id}`} className={"popular-game"}
                            onClick={() => navigate(`${paths.games.url}/${gameSlug(game)}`)}>
                    <img className={`popular-game-image ${game.image ? "" : "is-placeholder"}`}
                         src={game.image ? env.media + game.image : logo} alt={game.name}/>
                    <span className={"popular-game-play"}>Hemen Oyna</span>
                </div>
            })}
        </div>
    </div>;
}
